import PropTypes from "prop-types";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import colors from "constants/colors";

import IconLocation from "components/shared/svg/IconLocation";

import { Location, LocationText } from "./MyLocation.styled";

function MyLocation({ name, setSuggestions }) {
    const { setError } = useFormContext();
    const [loading, setLoadingGPS] = useState(false);

    function handleGeocode(result, status) {
        if (status === "OK") {
            const suggestions =
                result?.filter(
                    address => address.address_components.length > 4
                ) ?? [];

            if (setSuggestions) {
                setSuggestions(suggestions);
            }
        }

        if (status !== "OK") {
            setError(name, {
                type: "manual",
                message: "Er was een fout bij het ophalen van suggesties"
            });
        }
        setLoadingGPS(false);
    }

    function fetchNavigatorLocation() {
        navigator.geolocation.getCurrentPosition(
            async geolocation => {
                const lat = parseFloat(geolocation.coords.latitude);
                const lng = parseFloat(geolocation.coords.longitude);
                const latlng = `${lat},${lng}`;

                const query = `/api/google-maps/geocode/?latlng=${latlng}`;
                const response = await fetch(query);
                const data = await response.json();

                handleGeocode(data.results, data.status);
            },
            error => {
                let message;
                switch (error.code) {
                    case 1:
                        message =
                            "Geolocatie wordt door de browser geblokkeerd";
                        break;
                    case 2:
                        message = "Geen locatie beschikbaar";
                        break;
                    case 3:
                        message =
                            "Er was een fout bij het ophalen van uw geolocatie";
                        break;
                    default:
                        break;
                }

                if (message) {
                    setError(name, {
                        type: "manual",
                        message
                    });
                    setLoadingGPS(false);
                }
            }
        );
    }

    function onGPSClick() {
        if (navigator.geolocation) {
            setLoadingGPS(true);
            if (navigator?.permissions) {
                navigator.permissions
                    .query({ name: "geolocation" })
                    .then(status => {
                        if (
                            status.state === "granted" ||
                            status.state === "prompt"
                        ) {
                            fetchNavigatorLocation();
                        }
                    })
                    .catch(() => {
                        setError(name, {
                            type: "manual",
                            message: "Geblokkeerde geolocatie"
                        });
                        setLoadingGPS(false);
                    });
            }

            if (!navigator?.permissions) {
                fetchNavigatorLocation();
            }
        }

        if (!navigator?.geolocation) {
            setError(name, {
                type: "manual",
                message: "Geolocatie niet beschikbaar"
            });

            setLoadingGPS(false);
        }
    }

    return (
        <Location onClick={() => onGPSClick()} isLoading={!!loading}>
            <IconLocation fill={colors.peach} />
            <LocationText>Gebruik mijn locatie</LocationText>
        </Location>
    );
}

MyLocation.propTypes = {
    name: PropTypes.string.isRequired,
    setSuggestions: PropTypes.func.isRequired
};

export default MyLocation;
